import { SHOPIFY_LOCATION_CONNECTED_TO_3PL_MARKER } from '@threadheads/shared';
import { markedFieldMessage } from './markedFieldError';

/**
 * The sentence to show under the Shopify location field when a create or edit
 * would give one of the org's own locations a Shopify location that is already
 * connected to a partner warehouse, otherwise null.
 */
export const shopifyLocationConnectedMessage = (error: unknown) =>
  markedFieldMessage(error, SHOPIFY_LOCATION_CONNECTED_TO_3PL_MARKER);
